// import ReactDOM from "react-dom/client";
// import {
//   CometChatUIKit,
//   UIKitSettingsBuilder,
// } from "@cometchat/chat-uikit-react";
// import React from "react";
// import App from "App";
// import { setupLocalization } from "CometChat/utils/utils";
// import cometChatLogo from "../src/CometChat/assets/cometchat_logo.svg";
// import { CometChatProvider } from "CometChat/context/CometChatContext";
// /* ✅ MUST BE HERE */
// import "@cometchat/chat-uikit-react/css-variables.css";

// /**
//  * CometChat application constants
//  * @constant {Object} COMETCHAT_CONSTANTS
//  * @property {string} APP_ID - CometChat application ID
//  * @property {string} REGION - CometChat region
//  * @property {string} AUTH_KEY - CometChat authentication key
//  */
// export const COMETCHAT_CONSTANTS = {
//   APP_ID: "167401403aa7c5a02",
//   REGION: "in",
//   AUTH_KEY: "1f53fdff2f6dad543b0117f96e2ecf98bff902fa",
// };

// /**
//  * Initialize CometChat if credentials are available, otherwise render the app directly.
//  */
// if (
//   COMETCHAT_CONSTANTS.APP_ID &&
//   COMETCHAT_CONSTANTS.REGION &&
//   COMETCHAT_CONSTANTS.AUTH_KEY
// ) {
//   const uiKitSettings = new UIKitSettingsBuilder()
//     .setAppId(COMETCHAT_CONSTANTS.APP_ID)
//     .setRegion(COMETCHAT_CONSTANTS.REGION)
//     .setAuthKey(COMETCHAT_CONSTANTS.AUTH_KEY)
//     .subscribePresenceForAllUsers()
//     .build();

//   /**
//    * Initialize CometChat UIKit and render the application inside the CometChatProvider.
//    */
//   CometChatUIKit.init(uiKitSettings)?.then((response) => {
//     setupLocalization();
//     const root = ReactDOM.createRoot(
//       document.getElementById("root") as HTMLElement
//     );
//     root.render(
//       <CometChatProvider>
//         <App />
//       </CometChatProvider>
//     );
//   });
// } else {
//   /**
//    * If credentials are missing, render the app without initializing CometChat.
//    */
//   const root = ReactDOM.createRoot(
//     document.getElementById("root") as HTMLElement
//   );
//   root.render(
//     <div className="App" style={{ gap: "20px" }}>
//       <div className="cometchat-credentials__logo">
//         <img src={cometChatLogo} alt="CometChat Logo" />
//       </div>
//       <div className="cometchat-credentials__header">
//         CometChat App credentials are missing. Please add them in{" "}
//         <code>index.tsx</code> to continue.
//       </div>
//     </div>
//   );
// }
import React from "react";
import ReactDOM from "react-dom/client";
import {
  CometChatUIKit,
  CometChatUIKitLoginListener,
  UIKitSettingsBuilder,
} from "@cometchat/chat-uikit-react";
import { CometChatProvider } from "CometChat/context/CometChatContext";
import { setupLocalization } from "CometChat/utils/utils";
import App from "App";
import cometChatLogo from "CometChat/assets/cometchat_logo.svg";

/* REQUIRED CSS */
import "@cometchat/chat-uikit-react/css-variables.css";

/* ---------------- CONSTANTS ---------------- */
// export const COMETCHAT_CONSTANTS = {
//   APP_ID: "167401403aa7c5a02",
//   REGION: "in",
//   AUTH_KEY: "1f53fdff2f6dad543b0117f96e2ecf98bff902fa",
//   API_URL: "https://167401403aa7c5a02.api-in.cometchat.io/v3"
// };

// export const COMETCHAT_CONSTANTS = {
//   APP_ID: "16751841aac4dd449",
//   REGION: "us",
//   AUTH_KEY: "7ed650bd9b752efa8d611cdb2a8d38395f527993",
//   REST_API_KEY: "0d4f762e7892e3b0f7cb7ad3be94a5ddb2b4f566",
//   API_URL: "https://16751841aac4dd449.api-us.cometchat.io/v3"
// };


export const COMETCHAT_CONSTANTS = {
  APP_ID: "167714875b5da012d",
  REGION: "us",
  AUTH_KEY: "aebf9a661f618327aad35f93dcfdb140ab7bdb0a",
  REST_API_KEY: "0fd28de708658389eaf9e1e09ba2c2a89fcd2016",
  API_URL: "https://167714875b5da012d.api-us.cometchat.io/v3"
};

/* ---------------- SAFE INIT GUARD ---------------- */
let cometChatInitialized = false;

const rootElement = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

/* ---------------- INIT ---------------- */
if (
  COMETCHAT_CONSTANTS.APP_ID &&
  COMETCHAT_CONSTANTS.REGION &&
  COMETCHAT_CONSTANTS.AUTH_KEY
) {
  if (!cometChatInitialized) {
    cometChatInitialized = true;

    const uiKitSettings = new UIKitSettingsBuilder()
      .setAppId(COMETCHAT_CONSTANTS.APP_ID)
      .setRegion(COMETCHAT_CONSTANTS.REGION)
      .setAuthKey(COMETCHAT_CONSTANTS.AUTH_KEY)
      .subscribePresenceForAllUsers()
      .build();

    CometChatUIKit.init(uiKitSettings)
      ?.then(() => {
        setupLocalization();
        // 🔕 GLOBAL SOUND DISABLE — works for CometChat v6.3.5

        // (() => {
        //   const originalPlay = HTMLMediaElement.prototype.play;

        //   HTMLMediaElement.prototype.play = function () {
        //     this.muted = true;
        //     this.volume = 0;
        //     return originalPlay.apply(this, arguments as any);
        //   };
        // })();

        // 🔕 SAFE GLOBAL SILENT MODE — No runtime errors

        // (() => {
        //   HTMLMediaElement.prototype.play = function () {
        //     this.muted = true;
        //     this.volume = 0;

        //     // Immediately pause to prevent sound + Chrome error
        //     try {
        //       this.pause();
        //     } catch {}

        //     // Return resolved promise (play() normally returns Promise)
        //     return Promise.resolve();
        //   };
        // })();

        // const user = CometChatUIKitLoginListener.getLoggedInUser();

        // if (user) {
        //   const saved = localStorage.getItem(
        //     `chat_notifications_${user.getUid()}`
        //   );

        //   const notificationsEnabled =
        //     saved !== null ? JSON.parse(saved) : true; // default true
        //     console.log("notificationsEnabled->", notificationsEnabled);

        //   if (!notificationsEnabled) {
        //     (() => {
        //       HTMLMediaElement.prototype.play = function () {
        //         this.muted = true;
        //         this.volume = 0;
        //         try { this.pause(); } catch { }
        //         return Promise.resolve();
        //       };
        //     })();
        //   }
        // }

        // Save original play function once
        const originalPlay = HTMLMediaElement.prototype.play;

        function overrideAudio(silent: boolean) {
          if (silent) {
            console.log("Overriding play -> audio muted");
            HTMLMediaElement.prototype.play = function () {
              console.log("Muted play called on element:", this);
              this.muted = true;
              this.volume = 0;
              try { this.pause(); } catch (err) { console.error(err); }
              return Promise.resolve();
            };
          } else {
            console.log("Restoring original play");
            HTMLMediaElement.prototype.play = originalPlay;
          }
        }

        function checkNotifications() {
          const user = CometChatUIKitLoginListener.getLoggedInUser();
          // console.log("Logged-in user:", user);
          if (!user) return;

          const saved = localStorage.getItem(`chat_notifications_${user.getUid()}`);
          const notificationsEnabled = saved !== null ? JSON.parse(saved) : true;

          overrideAudio(!notificationsEnabled);
        }

        async function getNotifications() {
          const user = CometChatUIKitLoginListener.getLoggedInUser();
          console.log("Logged-in user:", user);
          if (!user) return;

          try {
            // Fetch latest notification settings from API
            const response = await fetch(`${API_BASE_URL}/notifications?user_id=${user.getUid()}`);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

            const data = await response.json();
            console.log("Notification API response:", data);

            // Convert "Sound Notifications" string to boolean
            const soundNotifRaw = data["Sound Notifications"];
            const notificationsEnabled = soundNotifRaw === true || soundNotifRaw === "true";

            // ✅ SAVE TO LOCALSTORAGE
            localStorage.setItem(
              `chat_notifications_${user.getUid()}`,
              JSON.stringify(notificationsEnabled)
            );

            // Apply overrideAudio based on latest setting
            overrideAudio(!notificationsEnabled);

          } catch (error) {
            console.error("Failed to fetch notification:", error);

            // Fallback: read from localStorage if API fails
            const saved = localStorage.getItem(`chat_notifications_${user.getUid()}`);
            const notificationsEnabled = saved !== null ? JSON.parse(saved) : true;
            overrideAudio(!notificationsEnabled);
          }
        }

        // Initial check
        getNotifications();

        // Check every 10 minute
        setInterval(checkNotifications, 10000);

        root.render(
          <CometChatProvider>
            <App />
          </CometChatProvider>
        );
      })
      .catch((err) => {
        console.error("CometChat init failed:", err);
      });
  }
} else {
  /* ---------------- FALLBACK ---------------- */
  root.render(
    <div className="App" style={{ gap: "20px" }}>
      <div className="cometchat-credentials__logo">
        <img src={cometChatLogo} alt="CometChat Logo" />
      </div>
      <div className="cometchat-credentials__header">
        CometChat App credentials are missing. Please add them in{" "}
        <code>index.tsx</code>.
      </div>
    </div>
  );
}
